import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SboxComponent } from "./sbox.component";
import { SearchboxV2Module } from "@shopping-angular-components/searchbox-v2/"
import { MainTitleModule } from '../main-title/main-title.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    SboxComponent
  ],
  exports: [
    SboxComponent
  ],
  imports: [
    SearchboxV2Module,
    CommonModule,
    MainTitleModule,
    TranslateModule
  ]
})
export class SboxModule {
}
